<template>
  <div>
    <resize-observer @notify="onNotify"/>
  </div>
</template>

<script>
  import 'vue-resize/dist/vue-resize.css'
  import {ResizeObserver} from 'vue-resize'
  import {
    SET_VIEWPORT_OBJECT,
  } from "../../services/constants"
  import {debounce} from "../../services/utilities"

  export default {
    name: 'ResponsiveHandlerComponent',
    components: {
      'resize-observer': ResizeObserver,
    },
    data() {
      return {
        updateCurrentViewportDebounced: null,
      }
    },
    computed: {},
    methods: {
      onNotify() {
        if (this.$currentViewport) {
          const obj = {
            label: this.$currentViewport.label,
            rule: this.$currentViewport.rule
          }
          this.updateCurrentViewportDebounced(obj)
        }
      },
      updateCurrentViewport(viewportObj) {
        this.$store.commit(SET_VIEWPORT_OBJECT, viewportObj)
      },
    },
    created() {
      this.updateCurrentViewportDebounced = debounce(this.updateCurrentViewport, 100, {leading: true})
      this.onNotify()
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  div {
    position: relative;
  }

</style>
